
import { GET_OFFER_STATE_HISTORY } from "helpers/url_helper"
import {
  GET_CURATOR_OFFERS_SUCCESS,
  GET_CURATOR_OFFERS_FAIL,
  CLEAR_CURATOR_OFFERS,
  GET_OPERATION_OFFERS_SUCCESS,
  GET_OPERATION_OFFERS_FAIL,
  CLEAR_OPERATION_OFFERS,
  GET_APPROVER_OFFERS_SUCCESS,
  GET_APPROVER_OFFERS_FAIL,
  CLEAR_APPROVER_OFFERS,
  GET_PUBLISHED_OFFERS_SUCCESS,
  GET_PUBLISHED_OFFERS_FAIL,
  CLEAR_PUBLISHED_OFFERS,
  MANAGE_CURATOR_OFFER_SUCCESS,
  MANAGE_CURATOR_OFFER_FAIL,
  MANAGE_OPERATION_OFFER_SUCCESS,
  MANAGE_OPERATION_OFFER_FAIL,
  MANAGE_PUBLISHED_OFFER_SUCCESS,
  MANAGE_PUBLISHED_OFFER_FAIL,
  GET_OFFER_TAGS,
  GET_OFFER_TAGS_SUCCESS,
  GET_OFFER_TAGS_FAIL,
  MANAGE_OFFER_TAG,
  MANAGE_OFFER_TAG_SUCCESS,
  MANAGE_OFFER_TAG_FAIL,
  CLEAR_OFFER_TAGS,
  GET_OFFER_TAG_DEFINITIONS,
  GET_OFFER_TAG_DEFINITIONS_SUCCESS,
  GET_OFFER_TAG_DEFINITIONS_FAIL,
  CLEAR_OFFER_TAG_DEFINITIONS,
  GET_OFFER_INCLUSIONS_SUCCESS,
  GET_OFFER_INCLUSIONS_FAIL,
  MANAGE_OFFER_INCLUSIONS,
  MANAGE_OFFER_INCLUSIONS_SUCCESS,
  MANAGE_OFFER_INCLUSIONS_FAIL,
  CLEAR_OFFER_INCLUSIONS,
  GET_OFFER_EXCLUSIONS_SUCCESS,
  GET_OFFER_EXCLUSIONS_FAIL,
  MANAGE_OFFER_EXCLUSIONS,
  MANAGE_OFFER_EXCLUSIONS_SUCCESS,
  MANAGE_OFFER_EXCLUSIONS_FAIL,
  CLEAR_OFFER_EXCLUSIONS,
  GET_OFFER_TERMS_CONDITIONS_SUCCESS,
  GET_OFFER_TERMS_CONDITIONS_FAIL,
  MANAGE_OFFER_TERMS_CONDITIONS,
  MANAGE_OFFER_TERMS_CONDITIONS_SUCCESS,
  MANAGE_OFFER_TERMS_CONDITIONS_FAIL,
  CLEAR_OFFER_TERMS_CONDITIONS,
  CLEAR_OFFER_INCLUSIONS_SUCCESS,
  CLEAR_OFFER_EXCLUSIONS_SUCCESS,
  CLEAR_OFFER_TERMS_CONDITIONS_SUCCESS,
  ADD_INCLUSION_TO_FORM,
  UPDATE_INCLUSION_IN_FORM,
  REMOVE_INCLUSION_FROM_FORM,
  CLEAR_INCLUSION_FORM,
  ADD_EXCLUSION_TO_FORM,
  UPDATE_EXCLUSION_IN_FORM,
  REMOVE_EXCLUSION_FROM_FORM,
  CLEAR_EXCLUSION_FORM,
  ADD_TERM_TO_FORM,
  UPDATE_TERM_IN_FORM,
  REMOVE_TERM_FROM_FORM,
  CLEAR_TERM_FORM,
  GET_OFFER_STATE_HISTORY_SUCCESS,
  GET_OFFER_STATE_HISTORY_FAIL,
  CLEAR_OFFER_STATE_HISTORY,
} from "./actionTypes"

const INIT_STATE = {
  curatorOffers: [],
  operationOffers: [],
  approverOffers: [],
  publishedOffers: [],

  curatorError: {},
  operationError: {},
  approverError: {},
  publishedError: {},
  curatorDeleteError: null,
  operationDeleteError: null,
  curatorCreationSuccess: null,
  operationCreationSuccess: null,
  curatorManagementSuccess: null,
  operationManagementSuccess: null,

  // Offer Tags -
  offerTags: [],
  tagError: null,
  isLoadingTags: false,
  tagManagementSuccess: null,

  // Offer Tag Definitions
  offerTagDefinitions: [],
  definitionError: null,
  isLoadingDefinitions: false,

  // Offer Inclusions
  offerInclusions: [],
  offerInclusionsError: null,
  isLoadingOfferInclusions: false,
  offerInclusionsManagementSuccess: false,

  // Offer Exclusions
  offerExclusions: [],
  offerExclusionsError: null,
  isLoadingOfferExclusions: false,
  offerExclusionsManagementSuccess: false,

  // Offer Terms & Conditions
  offerTermsConditions: [],
  offerTermsConditionsError: null,
  isLoadingOfferTermsConditions: false,
  offerTermsConditionsManagementSuccess: false,

  // Form data for local state management
  inclusionFormData: [],
  inclusionCreationSuccess: null,
  exclusionFormData: [],
  exclusionCreationSuccess: null,
  termFormData: [],
  termCreationSuccess: null,

  // Offer State History
  offerStateHistory: [],
  offerStateHistoryError: {},
  isLoadingOfferStateHistory: false,
}

const offers = (state = INIT_STATE, action) => {
  switch (action.type) {
    // ===== CURATOR OFFERS =====
    case GET_CURATOR_OFFERS_SUCCESS:
      return {
        ...state,
        curatorOffers: action.payload,
        curatorError: {},
      }

    case GET_CURATOR_OFFERS_FAIL:
      return {
        ...state,
        curatorError: action.payload,
      }

    case CLEAR_CURATOR_OFFERS:
      return {
        ...state,
        curatorOffers: [],
        curatorError: {},
      }

    // OPERATION OFFERS
    case GET_OPERATION_OFFERS_SUCCESS:
      return {
        ...state,
        operationOffers: action.payload,
        operationError: {},
      }

    case GET_OPERATION_OFFERS_FAIL:
      return {
        ...state,
        operationError: action.payload,
      }

    case CLEAR_OPERATION_OFFERS:
      return {
        ...state,
        operationOffers: [],
        operationError: {},
      }

    // APPROVER OFFERS
    case GET_APPROVER_OFFERS_SUCCESS:
      return {
        ...state,
        approverOffers: action.payload,
        approverError: {},
      }

    case GET_APPROVER_OFFERS_FAIL:
      return {
        ...state,
        approverError: action.payload,
      }

    case CLEAR_APPROVER_OFFERS:
      return {
        ...state,
        approverOffers: [],
        approverError: {},
      }

    // PUBLISHED OFFERS
    case GET_PUBLISHED_OFFERS_SUCCESS:
      return {
        ...state,
        publishedOffers: action.payload,
        publishedError: {},
      }

    case GET_PUBLISHED_OFFERS_FAIL:
      return {
        ...state,
        publishedError: action.payload,
      }

    case CLEAR_PUBLISHED_OFFERS:
      return {
        ...state,
        publishedOffers: [],
        publishedError: {},
      }

    // MANAGE CURATOR OFFER
    case MANAGE_CURATOR_OFFER_SUCCESS:
      return {
        ...state,
        curatorDeleteError: null,
        curatorCreationSuccess: action.payload,
        curatorManagementSuccess: action.payload,
      }

    case MANAGE_CURATOR_OFFER_FAIL:
      return {
        ...state,
        curatorDeleteError: action.payload,
        curatorCreationSuccess: null,
        curatorManagementSuccess: null,
      }

    // MANAGE OPERATION OFFER
    case MANAGE_OPERATION_OFFER_SUCCESS:
      return {
        ...state,
        operationDeleteError: null,
        operationCreationSuccess: action.payload,
        operationManagementSuccess: action.payload,
      }

    case MANAGE_OPERATION_OFFER_FAIL:
      return {
        ...state,
        operationDeleteError: action.payload,
        operationCreationSuccess: null,
        operationManagementSuccess: null,
      }

    case MANAGE_PUBLISHED_OFFER_SUCCESS:
      return {
        ...state,
        publishedDeleteError: null,
        publishedCreationSuccess: action.payload,
        publishedManagementSuccess: action.payload,
      }

    case MANAGE_PUBLISHED_OFFER_FAIL:
      return {
        ...state,
        publishedDeleteError: action.payload,
        publishedCreationSuccess: null,
        publishedManagementSuccess: null,
      }

    // OFFER TAGS
    case GET_OFFER_TAGS:
      return {
        ...state,
        isLoadingTags: true,
        tagError: null,
      }

    case GET_OFFER_TAGS_SUCCESS:
      return {
        ...state,
        offerTags: action.payload,
        isLoadingTags: false,
        tagError: null,
      }

    case GET_OFFER_TAGS_FAIL:
      return {
        ...state,
        isLoadingTags: false,
        tagError: action.payload,
      }

    case CLEAR_OFFER_TAGS:
      return {
        ...state,
        offerTags: [],
        tagError: null,
      }

    case MANAGE_OFFER_TAG:
      return {
        ...state,
        tagError: null,
        tagManagementSuccess: null,
      }

    case MANAGE_OFFER_TAG_SUCCESS:
      return {
        ...state,
        tagError: null,
        tagManagementSuccess: action.payload,
      }

    case MANAGE_OFFER_TAG_FAIL:
      return {
        ...state,
        tagError: action.payload,
        tagManagementSuccess: null,
      }

    // OFFER TAG DEFINITIONS
    case GET_OFFER_TAG_DEFINITIONS:
      return {
        ...state,
        isLoadingDefinitions: true,
        definitionError: null,
      }

    case GET_OFFER_TAG_DEFINITIONS_SUCCESS:
      return {
        ...state,
        offerTagDefinitions: action.payload,
        isLoadingDefinitions: false,
        definitionError: null,
      }

    case GET_OFFER_TAG_DEFINITIONS_FAIL:
      return {
        ...state,
        isLoadingDefinitions: false,
        definitionError: action.payload,
      }

    case CLEAR_OFFER_TAG_DEFINITIONS:
      return {
        ...state,
        offerTagDefinitions: [],
        definitionError: null,
      }

    // OFFER INCLUSIONS
    case GET_OFFER_INCLUSIONS_SUCCESS:
      return {
        ...state,
        offerInclusions: action.payload,
        offerInclusionsError: null,
        isLoadingOfferInclusions: false,
      }

    case GET_OFFER_INCLUSIONS_FAIL:
      return {
        ...state,
        offerInclusionsError: action.payload,
        isLoadingOfferInclusions: false,
      }

    case MANAGE_OFFER_INCLUSIONS:
      return {
        ...state,
        offerInclusionsManagementSuccess: false,
        offerInclusionsError: null,
        inclusionCreationSuccess: null,
      }

    case MANAGE_OFFER_INCLUSIONS_SUCCESS:
      return {
        ...state,
        offerInclusionsManagementSuccess: false,
        offerInclusionsError: null,
        inclusionCreationSuccess: action.payload,
        inclusionFormData: [],
      }

    case MANAGE_OFFER_INCLUSIONS_FAIL:
      return {
        ...state,
        offerInclusionsManagementSuccess: false,
        offerInclusionsError: action.payload,
      }

    case CLEAR_OFFER_INCLUSIONS:
      return {
        ...state,
        offerInclusions: [],
        offerInclusionsError: null,
        isLoadingOfferInclusions: false,
        offerInclusionsManagementSuccess: false,
      }

    // OFFER EXCLUSIONS
    case GET_OFFER_EXCLUSIONS_SUCCESS:
      return {
        ...state,
        offerExclusions: action.payload,
        offerExclusionsError: null,
        isLoadingOfferExclusions: false,
      }

    case GET_OFFER_EXCLUSIONS_FAIL:
      return {
        ...state,
        offerExclusionsError: action.payload,
        isLoadingOfferExclusions: false,
      }

    case MANAGE_OFFER_EXCLUSIONS:
      return {
        ...state,
        offerExclusionsManagementSuccess: false,
        offerExclusionsError: null,
        exclusionCreationSuccess: null,
      }

    case MANAGE_OFFER_EXCLUSIONS_SUCCESS:
      return {
        ...state,
        offerExclusionsManagementSuccess: false,
        offerExclusionsError: null,
        exclusionCreationSuccess: action.payload,
        exclusionFormData: [],
      }

    case MANAGE_OFFER_EXCLUSIONS_FAIL:
      return {
        ...state,
        offerExclusionsManagementSuccess: false,
        offerExclusionsError: action.payload,
      }

    case CLEAR_OFFER_EXCLUSIONS:
      return {
        ...state,
        offerExclusions: [],
        offerExclusionsError: null,
        isLoadingOfferExclusions: false,
        offerExclusionsManagementSuccess: false,
      }

    // OFFER TERMS & CONDITIONS
    case GET_OFFER_TERMS_CONDITIONS_SUCCESS:
      return {
        ...state,
        offerTermsConditions: action.payload,
        offerTermsConditionsError: null,
        isLoadingOfferTermsConditions: false,
      }

    case GET_OFFER_TERMS_CONDITIONS_FAIL:
      return {
        ...state,
        offerTermsConditionsError: action.payload,
        isLoadingOfferTermsConditions: false,
      }

    case MANAGE_OFFER_TERMS_CONDITIONS:
      return {
        ...state,
        offerTermsConditionsManagementSuccess: false,
        offerTermsConditionsError: null,
        termCreationSuccess: null,
      }

    case MANAGE_OFFER_TERMS_CONDITIONS_SUCCESS:
      return {
        ...state,
        offerTermsConditionsManagementSuccess: false,
        offerTermsConditionsError: null,
        termCreationSuccess: action.payload,
        termFormData: [],
      }

    case MANAGE_OFFER_TERMS_CONDITIONS_FAIL:
      return {
        ...state,
        offerTermsConditionsManagementSuccess: false,
        offerTermsConditionsError: action.payload,
      }

    case CLEAR_OFFER_TERMS_CONDITIONS:
      return {
        ...state,
        offerTermsConditions: [],
        offerTermsConditionsError: null,
        isLoadingOfferTermsConditions: false,
        offerTermsConditionsManagementSuccess: false,
      }

    // INCLUSION FORM MANAGEMENT
    case ADD_INCLUSION_TO_FORM:
      return {
        ...state,
        inclusionFormData: [...state.inclusionFormData, action.payload],
      }

    case UPDATE_INCLUSION_IN_FORM:
      return {
        ...state,
        inclusionFormData: state.inclusionFormData.map((inclusion, index) =>
          index === action.payload.index ? action.payload.inclusion : inclusion
        ),
      }

    case REMOVE_INCLUSION_FROM_FORM:
      return {
        ...state,
        inclusionFormData: state.inclusionFormData.filter(
          (_, index) => index !== action.payload
        ),
      }

    case CLEAR_INCLUSION_FORM:
      return {
        ...state,
        inclusionFormData: [],
      }

    // EXCLUSION FORM MANAGEMENT
    case ADD_EXCLUSION_TO_FORM:
      return {
        ...state,
        exclusionFormData: [...state.exclusionFormData, action.payload],
      }

    case UPDATE_EXCLUSION_IN_FORM:
      return {
        ...state,
        exclusionFormData: state.exclusionFormData.map((exclusion, index) =>
          index === action.payload.index ? action.payload.exclusion : exclusion
        ),
      }

    case REMOVE_EXCLUSION_FROM_FORM:
      return {
        ...state,
        exclusionFormData: state.exclusionFormData.filter(
          (_, index) => index !== action.payload
        ),
      }

    case CLEAR_EXCLUSION_FORM:
      return {
        ...state,
        exclusionFormData: [],
      }

    // TERM FORM MANAGEMENT
    case ADD_TERM_TO_FORM:
      return {
        ...state,
        termFormData: [...state.termFormData, action.payload],
      }

    case UPDATE_TERM_IN_FORM:
      return {
        ...state,
        termFormData: state.termFormData.map((term, index) =>
          index === action.payload.index ? action.payload.term : term
        ),
      }

    case REMOVE_TERM_FROM_FORM:
      return {
        ...state,
        termFormData: state.termFormData.filter(
          (_, index) => index !== action.payload
        ),
      }

    case CLEAR_TERM_FORM:
      return {
        ...state,
        termFormData: [],
      }

    case CLEAR_OFFER_INCLUSIONS_SUCCESS:
      return {
        ...state,
        offerInclusionsManagementSuccess: false,
      }

    case CLEAR_OFFER_EXCLUSIONS_SUCCESS:
      return {
        ...state,
        offerExclusionsManagementSuccess: false,
      }

    case CLEAR_OFFER_TERMS_CONDITIONS_SUCCESS:
      return {
        ...state,
        offerTermsConditionsManagementSuccess: false,
      }

    case GET_OFFER_STATE_HISTORY:
      return {
        ...state,
        isLoadingOfferStateHistory: true,
        offerStateHistoryError: {},
      }

    case GET_OFFER_STATE_HISTORY_SUCCESS:
      return {
        ...state,
        offerStateHistory: action.payload,
        isLoadingOfferStateHistory: false,
        offerStateHistoryError: {},
      }

    case GET_OFFER_STATE_HISTORY_FAIL:
      return {
        ...state,
        offerStateHistoryError: action.payload,
        isLoadingOfferStateHistory: false,
      }

    case CLEAR_OFFER_STATE_HISTORY:
      return {
        ...state,
        offerStateHistory: [],
        offerStateHistoryError: {},
        isLoadingOfferStateHistory: false,
      }

    default:
      return { ...state }
  }
}

export default offers